/* eslint-disable no-loop-func */

export function CheckPresent(data, teamMembers) {
  const memberIds = teamMembers.map((m) => m.userUID);
  const userData = data.map((el) => (el?.success ? el.data : null));
  const dataToSend = [];
  const presentMembers = [];

  userData.forEach((element, i) => {
    if (element === null) {
      dataToSend.push('-');
      presentMembers.push('-');
    } else {
      const presentMember = teamMembers.filter(
        (m) => element[m.userUID] && element[m.userUID].present === true
      );
      presentMembers[i] = presentMember;
      dataToSend.push(presentMember.length);
    }
  });

  return {
    dataToShow: dataToSend,
    presentMembers,
  };
}
